import { reactive } from "vue";

const timeout = 4000;
const timeouts: number[] = [];
export const tilingSpeakers = reactive<string[]>([]);

export function setSpeaker(uid: string, id: number) {
  if(tilingSpeakers.includes(uid)) return;
  if (timeouts[id]) {
    if (timeouts[id] + timeout < Date.now()) {
      timeouts[id] = Date.now();
      tilingSpeakers[id] = uid;
    }
  } else {
    timeouts[id] = Date.now();
    tilingSpeakers[id] = uid;
  }
}

export function resetTilingSpeakers() {
  timeouts.length = 0
  tilingSpeakers.length = 0
}
